let Api = {
	"SZGX_W_PRODUCT_FINDPAGELIST": "/b2b/n/ShopHome/portalFindEsProductPageList", //B2B查询商品列表
	"B2B_N_COMM_GOODS_FINDIDS": "/b2b/n/commSaleCatg/list", //店铺类目
	"B2B_N_COMM_GOODSCLASSMAGE_FINDALL": "/b2b/n/IndustryColumnManage/findList", //商品类别
	
	"SZGX_W_SHOPINFO_LISTBYID": "/b2b/n/shopInfo/findShopListByIds", //B2B供应商列表
	"B2B_TRADE_W_COMMSALECATG_PAGE": "/b2b/w/commSaleCatg/findPage", //获取商品销售分类分页列表

	"B2B_W_INDUSTRYARTICLEMAGE_FINDPAGELIST": "/b2b/w/industryArticleMage/portalFindPageList", //分页查询列表
	"B2B_W_INDUSTRYAR_STRYARTICLECLASSMAGETREE": "/b2b/w/industryArticleClassMage/findPageIndustryArticleClassMageTree", //分页查询文章分类树
	"B2B_W_INDUSTRYARTICLEMAGE_SAVEORUPDATE": "/b2b/w/industryArticleMage/saveOrUpdate", //新增或修改
	"B2B_W_INDUSTRYARTICLEMAGE_FINDINFO": "/b2b/w/industryArticleMage/findInfo", //查询详细信息
	"B2B_W_INDUSTRYARTICLECLASSMAGE_DEL": "/b2b/w/industryArticleClassMage/del", //删除
	"B2B_W_INDUSTRYARTICLECLASSMAGE_FINDINDUSTRYARTICLECLASSMAGETREE": "/b2b/w/industryArticleClassMage/findIndustryArticleClassMageTree", //查询基础品类树
	"B2B_W_INDUSTRYCOLUMNMANAGE_FINDPAGELIST": "/b2b/w/IndustryColumnManage/findPageList", //栏目管理
	"B2B_W_INDUSTRYCOLUMNMANAGE_SAVEORUPDATE": "/b2b/w/IndustryColumnManage/saveOrUpdate", //栏目管理新增编辑
	"B2B_W_INDUSTRYCOLUMNMANAGE_FINDLIST": "/b2b/w/IndustryColumnManage/findList", //栏目管理查询列表
	"B2B_W_INDUSTRYCOLUMNMANAGE_DEL": "/b2b/w/IndustryColumnManage/del", //栏目管理删除
	"B2B_W_INDUSTRYCOLUMNMANAGE_FINDINFO": "/b2b/w/IndustryColumnManage/findInfo", //栏目管理详情

	
	"B2B_W_INDUSTRYARTICLEMAGE_FINDIDS": "/b2b/w/industryArticleMage/findIds", //查询当前文章是否还存在


	"B2B_N_INDUSTRYCERTIFICATION_FINDALL": "/b2b/n/IndustryCertification/findList", //查询所有商务资质

	
	
	
}
module.exports = Api